import jwtDecode, { JwtPayload } from 'jwt-decode';
import translate from '../list/utils/translate';

export type Token = {
    value: string;
    expirationTime: number;
};
export type Tokens = {
    auth?: Token;
    guest?: Token;
};
export type AuthenticationState = {
    tokens: Tokens;
    currentToken: string;
    isLoggedIn: boolean;
};

const isExpiredOrInvalidToken = (accessToken: string) => {
    if (accessToken) {
        const decodedToken = jwtDecode<JwtPayload>(accessToken);
        return Number(decodedToken.exp) < new Date().getTime() / 1000;
    }
    return true;
};

const isTokenValid = (value: string) => {
    if (isExpiredOrInvalidToken(value)) {
        window?.ikea?.toast(
            translate('Get session error'),
            {
                label: translate('Reload'),
                callbackOrHref: () => window.location.reload(),
            },
            null
        );
        return false;
    }
    return true;
};

// Prefers logged in tokens, falls back to guest token
// Check for the validity of both guest and auth token
const pickToken = (tokens: Tokens) =>
    tokens.auth && isTokenValid(tokens.auth.value)
        ? tokens.auth.value
        : tokens.guest && isTokenValid(tokens.guest.value)
        ? tokens.guest.value
        : '';

export default () => {
    return new Promise<string>((resolve, reject) => {
        return window?.ikea?.authentication?.getTokens((error: any, tokens: Tokens) => {
            if (error) {
                window?.ikea?.toast(
                    translate('Get session error'),
                    {
                        label: translate('Reload'),
                        callbackOrHref: () => window.location.reload(),
                    },
                    null
                );
                return reject(error);
            }
            // Checks for current token not to be invalid or null
            if (!pickToken(tokens)) {
                return reject();
            }
            return resolve(pickToken(tokens));
        });
    });
};
